const context = "config";
const abrev = "conf";

export default [
    {
        path: "/conta/altera-usuario",
        name: "altera-usuario",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/conta/AlteraUsuario.vue"),
    },
    {
        path: "/conta/alerta/:idempresa",
        name: "edit-alerta",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/conta/Alerta.vue"),
    },
    {
        path: "/conta/alertas",
        name: "alertas",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/conta/Alertas.vue"),
    },
    {
        path: "/conta/grupo-permissoes",
        name: "grupopermissoes",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/conta/GrupoPermissoes.vue"),
    },
    {
        path: "/conta/grupopermissao",
        name: "new-grupopermissao",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/conta/GrupoPermissao.vue"),
    },
    {
        path: "/conta/grupopermissao/:id",
        name: "edit-grupopermissao",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/conta/GrupoPermissao.vue"),
    },
    {
        path: "/config/map",
        name: "configuracao-mapas",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/conta/ConfigMapas.vue"),
    },
    {
        path: "/config/smtp",
        name: "configuracao-smtp",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/conta/ConfigSmtp.vue"),
    },
    {
        path: "/config/contrasenha",
        name: "contrassenha",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/conta/Contrasenha.vue"),
    },
    {
        path: "/acesso-nao-permitido/:tela",
        name: "acesso-nao-permitido-tela",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/shared/tela/AccessDenied.vue"),
        props: {
            header: true,
            content: true
        },
    },
    {
        path: "/config/parametrizacoes",
        name: "config-parametrizacoes",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/conta/parametrizacoes/ParametrizacoesList.vue"),
        children: [
            {
                path: "new", 
                name: "config-parametrizacoes-new",
                meta: { contexto: context, abrev: abrev },
                component: () => import("@/components/conta/parametrizacoes/pages/UserParametrizacaoManage.vue"),
            },
            {
                path: 'edit/:id/:idusuario/:config',
                name: 'config-parametrizacoes-edit',
                meta: { contexto: context, abrev: abrev },
                component: () => import("@/components/conta/parametrizacoes/pages/UserParametrizacaoManage.vue"),
                props: route => ({ 
                    id: Number(route.params.id), 
                    idusuario: Number(route.params.idusuario), 
                    config: route.params.config
                })

            },
        ],
    },
    {
        path: "/licencas-comerciais",
        name: "licencas-comerciais",
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/shared/Licencas.vue')
    },
];
